// frontend/src/services/comprasService.js
import api from './apiService';

const LOCAIS = 'financeiro/locais-compra/';
const LISTAS = 'financeiro/listas-compra/';
const ITENS = 'financeiro/itens-lista-compra/';
const SECOES = 'financeiro/secoes-compra/';

// --- Locais de compra ---
export const getLocaisCompra = async (params = {}) => {
  const { data } = await api.get(LOCAIS, { params });
  return Array.isArray(data) ? data : data?.results || [];
};

export const getLocalCompra = async (id) => {
  const { data } = await api.get(`${LOCAIS}${id}/`);
  return data;
};

export const createLocalCompra = async (payload) => {
  const { data } = await api.post(LOCAIS, payload);
  return data;
};

export const updateLocalCompra = async (id, payload) => {
  const { data } = await api.patch(`${LOCAIS}${id}/`, payload);
  return data;
};

export const arquivarLocalCompra = async (id) => {
  await api.delete(`${LOCAIS}${id}/`);
};

export const reativarLocalCompra = async (id) => {
  const { data } = await api.post(`${LOCAIS}${id}/reativar/`);
  return data;
};

/** "Organizar": move as listas de um local genérico para estabelecimentos específicos.
 * @param {Array<{lista_id:number, estabelecimento:string}>} atribuicoes
 */
export const desmembrarLocal = async (id, atribuicoes) => {
  const { data } = await api.post(`${LOCAIS}${id}/desmembrar/`, { atribuicoes });
  return data;
};

// --- Listas de compra ---
export const getListasCompra = async (params = {}) => {
  const { data } = await api.get(LISTAS, { params });
  return Array.isArray(data) ? data : data?.results || [];
};

export const getListaCompra = async (id) => {
  const { data } = await api.get(`${LISTAS}${id}/`);
  return data;
};

/**
 * @param {object} payload { local, titulo?, data_compra?, observacao?, eh_modelo?, ponto_partida?, origem? }
 */
export const createListaCompra = async (payload) => {
  const { data } = await api.post(LISTAS, payload);
  return data;
};

export const updateListaCompra = async (id, payload) => {
  const { data } = await api.patch(`${LISTAS}${id}/`, payload);
  return data;
};

export const deleteListaCompra = async (id) => {
  await api.delete(`${LISTAS}${id}/`);
};

export const duplicarListaCompra = async (id) => {
  const { data } = await api.post(`${LISTAS}${id}/duplicar/`);
  return data;
};

export const salvarListaComoModelo = async (id, titulo = '') => {
  const { data } = await api.post(`${LISTAS}${id}/salvar-como-modelo/`, { titulo });
  return data;
};

export const getPreviewLancamento = async (id) => {
  const { data } = await api.get(`${LISTAS}${id}/preview-lancamento/`);
  return data;
};

/** Nova lista RASCUNHO com os itens que ficaram de fora desta compra (não encontrados,
 * caros demais ou não alcançados). 400 quando não há pendentes. */
export const criarListaPendentes = async (id) => {
  const { data } = await api.post(`${LISTAS}${id}/criar-lista-pendentes/`);
  return data;
};

/** Conclui a compra e registra o histórico de preços — sem lançar no financeiro. */
export const concluirListaCompra = async (id, estabelecimento = '') => {
  const { data } = await api.post(`${LISTAS}${id}/concluir/`, { estabelecimento });
  return data;
};

/**
 * @param {object} payload { descricao, valor, categoria, data, conta|cartao, cartao_adicional?, status? }
 */
export const lancarListaCompra = async (id, payload) => {
  const { data } = await api.post(`${LISTAS}${id}/lancar/`, payload);
  return data;
};

// --- Lançamento/verificação de preço por item (wishlist de marketplace) ---
export const getPreviewLancamentoItem = async (id) => {
  const { data } = await api.get(`${ITENS}${id}/preview-lancamento/`);
  return data;
};

/**
 * @param {object} payload { descricao, valor, categoria, data, conta|cartao, cartao_adicional?, status?, ignorar_reflexao? }
 */
export const lancarItem = async (id, payload) => {
  const { data } = await api.post(`${ITENS}${id}/lancar/`, payload);
  return data;
};

/** Verificação manual de preço a partir do link do produto. */
export const verificarPrecoItem = async (id, { preco, data: dataRef } = {}) => {
  const { data } = await api.post(`${ITENS}${id}/verificar-preco/`, { preco, data: dataRef });
  return data;
};

// --- Itens ---
export const getItensLista = async (listaId) => {
  const { data } = await api.get(ITENS, { params: { lista: listaId } });
  return Array.isArray(data) ? data : data?.results || [];
};

export const createItemLista = async (payload) => {
  const { data } = await api.post(ITENS, payload);
  return data;
};

export const updateItemLista = async (id, payload) => {
  const { data } = await api.patch(`${ITENS}${id}/`, payload);
  return data;
};

export const deleteItemLista = async (id) => {
  await api.delete(`${ITENS}${id}/`);
};

/**
 * Sync em lote do "modo compra".
 * @param {number} listaId
 * @param {Array<{id:number, preco_unitario?:string|number, comprado?:boolean, quantidade?:string|number}>} itens
 */
export const bulkUpdateItens = async (listaId, itens) => {
  const { data } = await api.patch(`${ITENS}bulk/`, { lista: listaId, itens });
  return data;
};

// --- Seções (corredores da loja) ---
export const getSecoesCompra = async () => {
  const { data } = await api.get(SECOES);
  return Array.isArray(data) ? data : data?.results || [];
};

export const createSecaoCompra = async (nome) => {
  const { data } = await api.post(SECOES, { nome });
  return data;
};

export const updateSecaoCompra = async (id, payload) => {
  const { data } = await api.patch(`${SECOES}${id}/`, payload);
  return data;
};

export const deleteSecaoCompra = async (id) => {
  await api.delete(`${SECOES}${id}/`);
};

/** Grava a ordem dos corredores. @param {number[]} ordem ids na nova ordem */
export const reordenarSecoesCompra = async (ordem) => {
  const { data } = await api.post(`${SECOES}reordenar/`, { ordem });
  return Array.isArray(data) ? data : [];
};

// --- Fase 2: histórico / ficha do produto ---
export const getProdutosCompra = async (params = {}) => {
  const { data } = await api.get('financeiro/compras/produtos/', { params });
  return Array.isArray(data) ? data : [];
};

/** "Produtos frequentes" ao montar uma lista — já comprado OU já adicionado antes numa
 * lista de supermercado/atacadista, mesmo sem ter concluído a compra. */
export const getProdutosRecorrentes = async (excluirListaId) => {
  const { data } = await api.get('financeiro/compras/produtos/recorrentes/', {
    params: excluirListaId ? { excluir_lista: excluirListaId } : {},
  });
  return Array.isArray(data) ? data : [];
};

export const getFichaProduto = async (chave) => {
  const { data } = await api.get('financeiro/compras/produtos/ficha/', {
    params: { produto: chave },
  });
  return data;
};

/** Resolve um código de barras: catálogo interno → Open Food Facts. */
export const getProdutoPorGtin = async (gtin) => {
  const { data } = await api.get('financeiro/compras/produto-por-gtin/', { params: { gtin } });
  return data; // { found, gtin, nome?, marca?, conteudo? }
};

/** Contribuição do catálogo colaborativo (1º a nomear um GTIN novo). */
export const contribuirProdutoCatalogo = async ({ gtin, nome, marca = '' }) => {
  const { data } = await api.post('financeiro/compras/produto-por-gtin/', { gtin, nome, marca });
  return data;
};

/** Último preço pago pelo produto (prefere o mesmo local da lista). */
export const getSugestaoPreco = async ({ lista, nome, gtin }) => {
  const { data } = await api.get('financeiro/compras/sugestao-preco/', {
    params: { lista, nome: nome || '', gtin: gtin || '' },
  });
  return data; // {} | { preco_estimado, local, data, mesmo_local }
};

// --- Fase 3: insights ---
export const getComparadorMercado = async (listaId) => {
  const { data } = await api.get('financeiro/compras/comparador/', { params: { lista: listaId } });
  return data;
};

export const getResumoInsights = async () => {
  const { data } = await api.get('financeiro/compras/insights/resumo/');
  return data;
};

/** Relatório mensal de compras. `ref` = 'YYYY-MM' (default: mês atual). */
export const getRelatorioCompras = async (ref) => {
  const params = {};
  if (ref) {
    const [ano, mes] = ref.split('-');
    params.ano = ano;
    params.mes = mes;
  }
  const { data } = await api.get('financeiro/compras/relatorio/', { params });
  return data;
};

export const getAlertaOrcamento = async (listaId) => {
  const { data } = await api.get('financeiro/compras/orcamento-alerta/', { params: { lista: listaId } });
  return data; // {} | { categoria, meta, gasto_mes, restante, previsto_lista, vai_estourar, estouro }
};

/** Itens precificados acima da média histórica do produto (> 10%). */
export const getAlertasPreco = async (listaId) => {
  const { data } = await api.get('financeiro/compras/alertas-preco/', { params: { lista: listaId } });
  return Array.isArray(data) ? data : [];
};

export const UNIDADES = [
  { value: 'UN', label: 'un' },
  { value: 'KG', label: 'kg' },
  { value: 'G', label: 'g' },
  { value: 'L', label: 'L' },
  { value: 'ML', label: 'ml' },
  { value: 'CX', label: 'cx' },
  { value: 'PCT', label: 'pct' },
  { value: 'DZ', label: 'dz' },
];

export const PRIORIDADES = [
  { value: 'ALTA', label: 'Alta', color: 'red' },
  { value: 'MEDIA', label: 'Média', color: 'gold' },
  { value: 'BAIXA', label: 'Baixa', color: 'default' },
];
